"use client"
import React from 'react'
import { createPortal } from 'react-dom'
// import { Card, CardContent } from "@/components/ui/card"
import Autoplay from "embla-carousel-autoplay"
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
    type CarouselApi,
} from "@/components/ui/carousel"

import ImageHoverVideo from '@/app/components/ImageHoverVideo'
import WatermarkBadge from '@/app/components/WatermarkBadge'


let showcase1 = {
    name: 'OpenAI / ChatGPT',
    slug: 'openai',
    //thumbnail: require('@/img/showcase/thumbnails/openai.com.png').default,
    //video: require('@/videos/showcase/openai.com.mp4').default,
    thumbnail: '../../img/gamepic/14.Ludo2.png',
    video: '../../img/gamepic/1Ludo.mp4',
    description: 'Marketing website & chat interface',
}



export const showcase = [
    {
        thumbnail: '../../img/gamepic/14.Ludo1.png',
        video: '../../img/gamepic/1Ludo.mp4',
        description: '',
    },
    {
        thumbnail: '../../img/gamepic/14.Ludo2.png',
        video: '../../img/gamepic/1Ludo.mp4',
        description: '',
    },
    {
        thumbnail: '../../img/gamepic/14.Ludo3.png',
        video: '../../img/gamepic/1Ludo.mp4',
        description: '',
    },
    {
        thumbnail: '../../img/gamepic/14.Ludo4.png',
        video: '../../img/gamepic/1Ludo.mp4',
        description: '',
    },
]

export default function GameDetailCarousel({ showcase }: any) {

    const [api, setApi] = React.useState<CarouselApi>()
    const [current, setCurrent] = React.useState(0)
    const [count, setCount] = React.useState(0)
    // 大图预览：showcase 下标，null 为关闭
    const [preview, setPreview] = React.useState<number | null>(null)

    React.useEffect(() => {
        if (!api) {
            return
        }


        setCount(api.scrollSnapList().length)
        setCurrent(api.selectedScrollSnap() + 1)

        api.on("select", () => {
            setCurrent(api.selectedScrollSnap() + 1)
        })
    }, [api])

    // 大图预览开启时：Esc 关闭、← → 切换，并锁定背景滚动
    React.useEffect(() => {
        if (preview === null) return
        const len = showcase.length
        const onKey = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setPreview(null)
            if (e.key === 'ArrowLeft') setPreview((p) => (p === null ? p : (p - 1 + len) % len))
            if (e.key === 'ArrowRight') setPreview((p) => (p === null ? p : (p + 1) % len))
        }
        window.addEventListener('keydown', onKey)
        document.body.style.overflow = 'hidden'
        return () => {
            window.removeEventListener('keydown', onKey)
            document.body.style.overflow = ''
        }
    }, [preview, showcase.length])

    return (
        <>
            <Carousel setApi={setApi} className="w-full max-w-xs"
                plugins={[
                    Autoplay({
                        delay: 10000,
                    }),
                ]}>
                <CarouselContent>
                    {/* {Array.from({ length: 5 }).map((_, index) => ( */}
                    {/* <CarouselItem key="1">
                        <div className="space-y-8 bg-white p-2  rounded-xl">
                            <video
                                //ref={mediaRef}
                                aria-hidden="true"
                                muted
                                loop
                                className=""
                                autoPlay
                                playsInline
                            >
                                <source src="../../img/gamepic/1Ludo.mp4" type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </CarouselItem> */}

                    {showcase.map((site: any, siteIndex: number) => (
                        //图片hover视频，因为没有视频所以放弃
                        // <CarouselItem key={siteIndex}>
                        //     <div className="space-y-8 bg-white p-2  rounded-xl hover:cursor-pointer">
                        //         <div><ul><ImageHoverVideo key={siteIndex} site={site} priority={siteIndex < 6} /></ul></div>
                        //     </div>
                        // </CarouselItem>

                        <CarouselItem key={siteIndex}>
                            <div className=" space-y-8 bg-white p-2  rounded-xl   content-center" >
                                {/* //h-[650px] */}
                                <img src={site.thumbnail} className=' w-full rounded-lg cursor-zoom-in ' loading="lazy"
                                    onClick={() => setPreview(siteIndex)} />
                            </div>
                        </CarouselItem>

                    ))}

                    {/* <CarouselItem key="2">
                        <div className=" space-y-8 bg-white p-2  rounded-xl">
                            <img src="../../img/gamepic/14.Ludo1.png" className=' w-full h-2/3 rounded-lg ' loading="lazy" />
                        </div>
                    </CarouselItem>

                    <CarouselItem key="3">
                        <div className="space-y-8 bg-white p-2  rounded-xl">
                            <img src="../../img/gamepic/14.Ludo2.png" className='  w-full h-2/3' />
                        </div>
                    </CarouselItem>
                    <CarouselItem key="4">
                        <div className="space-y-8 bg-white p-2  rounded-xl">
                            <img src="../../img/gamepic/14.Ludo3.png" className='  w-full h-2/3' />
                        </div>
                    </CarouselItem>
                    <CarouselItem key="5">
                        <div className="space-y-8 bg-white p-2  rounded-xl">
                            <img src="../../img/gamepic/14.Ludo4.png" className='  w-full h-2/3' />
                        </div>
                    </CarouselItem>
                    <CarouselItem key="16">
                        <div className="space-y-8 bg-white p-2  rounded-xl">
                            <div><ul><ImageHoverVideo site={showcase1} priority={false} /></ul></div>
                        </div>
                    </CarouselItem> */}
                    {/* ))} */}
                </CarouselContent>
                <CarouselPrevious />
                <CarouselNext />
            </Carousel>
            {/* <div className="py-0 text-center text-sm text-muted-foreground">
                Slide {current} of {count}
            </div> */}
            {/* <div className="absolute bottom-4 left-2/4 z-50 flex -translate-x-2/4 gap-2">
                <span className={`block h-1 cursor-pointer rounded-2xl transition-all content-[''] ${current === 1 ? "w-8 bg-black" : "w-4  bg-slate-700"
                    }`} />
            </div> */}
            {/* <div className="absolute -bottom-4 left-2/4 z-10 flex -translate-x-2/4 gap-2">
                {new Array(count).fill("").map((_, i) => (
                    <span
                        key={i}
                        className={`block h-1 cursor-pointer rounded-2xl transition-all content-[''] ${current === i ? "w-8 bg-black" : "w-4 bg-slate/700"
                            }`}
                        onClick={() => setCurrent(i)}
                    />
                ))}
            </div> */}
            <div className="absolute -bottom-4 left-2/4 z-10 flex -translate-x-2/4 gap-2">

                {/* 固定4个修改为动态读取 */}
                {/* <span

                    className={`block h-1 cursor-pointer rounded-2xl transition-all content-[''] ${current === 1 ? "w-10 bg-gradient-to-r from-green-600 via-blue-500 to-purple-600" : "w-4 bg-black"
                        }`}
                    onClick={() => api!.scrollTo(0)}
                />
                <span

                    className={`block h-1 cursor-pointer rounded-2xl transition-all content-[''] ${current === 2 ? "w-10 bg-gradient-to-r from-green-600 via-blue-500 to-purple-600" : "w-4 bg-black"
                        }`}
                    onClick={() => api!.scrollTo(1)}
                />
                <span

                    className={`block h-1 cursor-pointer rounded-2xl transition-all content-[''] ${current === 3 ? "w-10 bg-gradient-to-r from-green-600 via-blue-500 to-purple-600" : "w-4 bg-black"
                        }`}
                    onClick={() => api!.scrollTo(2)}
                />
                <span

                    className={`block h-1 cursor-pointer rounded-2xl transition-all content-[''] ${current === 4 ? "w-10 bg-gradient-to-r from-green-600 via-blue-500 to-purple-600" : "w-4 bg-black"
                        }`}
                    onClick={() => api!.scrollTo(3)}
                /> */}


                {showcase.map((site: any, siteIndex: number) => (

                    <span
                        key={siteIndex}
                        className={`block h-1 cursor-pointer rounded-2xl transition-all content-[''] ${current === siteIndex+1 ? "w-10 bg-gradient-to-r from-green-600 via-blue-500 to-purple-600" : "w-4 bg-black"
                            }`}
                        onClick={() => api!.scrollTo(siteIndex+1)}
                    />
                ))}


            </div>

            {/* 大图预览：点遮罩/× 关闭，左右箭头或方向键切换；有视频则播视频。
                必须 portal 到 body：祖先有 BlurFade 等 transform/filter 动画，否则 fixed 定位会失效 */}
            {preview !== null && showcase[preview] && createPortal(
                <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 p-6"
                    onClick={() => setPreview(null)}>
                    <button type="button" aria-label="关闭"
                        className="absolute right-4 top-4 text-3xl leading-none text-white/70 hover:text-white"
                        onClick={() => setPreview(null)}>×</button>
                    {showcase.length > 1 && (
                        <>
                            <button type="button" aria-label="上一张"
                                className="absolute left-4 top-1/2 -translate-y-1/2 rounded-full bg-white/10 px-3 py-1 text-2xl text-white/80 hover:bg-white/20"
                                onClick={(e) => { e.stopPropagation(); setPreview((preview - 1 + showcase.length) % showcase.length) }}>‹</button>
                            <button type="button" aria-label="下一张"
                                className="absolute right-4 top-1/2 -translate-y-1/2 rounded-full bg-white/10 px-3 py-1 text-2xl text-white/80 hover:bg-white/20"
                                onClick={(e) => { e.stopPropagation(); setPreview((preview + 1) % showcase.length) }}>›</button>
                        </>
                    )}
                    {showcase[preview].video ? (
                        <div className="relative" onClick={(e) => e.stopPropagation()}>
                            <video src={showcase[preview].video} poster={showcase[preview].thumbnail} controls autoPlay
                                controlsList="nodownload" onContextMenu={(e) => e.preventDefault()}
                                className="max-h-[90vh] max-w-[90vw] rounded-lg" />
                            <WatermarkBadge />
                        </div>
                    ) : (
                        <div className="relative" onClick={(e) => e.stopPropagation()}>
                            <img src={showcase[preview].thumbnail} alt="" draggable={false}
                                onContextMenu={(e) => e.preventDefault()}
                                className="max-h-[90vh] max-w-[90vw] rounded-lg object-contain" />
                            <WatermarkBadge />
                        </div>
                    )}
                    <p className="absolute bottom-4 left-1/2 -translate-x-1/2 text-xs text-white/60">
                        {preview + 1} / {showcase.length}
                    </p>
                </div>,
                document.body
            )}



        </>

    )
}
